var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloadStep1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    fill: "none",
    customFrame: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint_linear_0",
    x1: 16.4267769,
    x2: 30.6392231,
    y1: 15.3339844,
    y2: 28.4317017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgb(151,87,230)",
    offset: 0,
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgb(118,56,241)",
    offset: 0.999890745,
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint_linear_1",
    x1: 20.1468143,
    x2: 36.6571922,
    y1: 21.3337955,
    y2: 35.8345718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgb(255,255,255)",
    offset: 0,
    stopOpacity: 0.259751976
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgb(147,83,232)",
    offset: 0.999890745,
    stopOpacity: 0.637265086
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint_linear_2",
    x1: 28,
    x2: 28,
    y1: 18.25,
    y2: 36.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgb(255,255,255)",
    offset: 0,
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgb(255,255,255)",
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint_linear_3",
    x1: 26.0767632,
    x2: 32.2296753,
    y1: 22.2380047,
    y2: 32.7888451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgb(255,255,255)",
    offset: 0,
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgb(255,255,255)",
    offset: 1,
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint_linear_4",
    x1: 24.7420387,
    x2: 32.3831139,
    y1: 32.8734856,
    y2: 36.2767792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgb(255,255,255)",
    offset: 0,
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgb(255,255,255)",
    offset: 1,
    stopOpacity: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4\\u5408 1"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706\\u5F62",
    cx: 24,
    cy: 24,
    r: 24,
    fill: "rgb(141,86,233)",
    fillOpacity: 0.110932037
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-27"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    width: 19,
    height: 26,
    x: 12,
    y: 11,
    rx: 2,
    fill: "url(#paint_linear_0)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    width: 17.5,
    height: 18.5,
    x: 19.25,
    y: 18.25,
    rx: 2,
    fill: "url(#paint_linear_1)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    width: 17.5,
    height: 18.5,
    x: 19.25,
    y: 18.25,
    rx: 2,
    stroke: "url(#paint_linear_2)",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u4E0B\\u8F7Dapp"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84",
    d: "M25.3692 24.6037C25.3692 23.9613 25.3675 23.3156 25.3692 22.6732C25.3709 21.679 26.0438 21.0008 27.0278 21.0008C27.6703 20.9991 28.3111 21.0008 28.9535 21.0008C29.9595 21.0008 30.6291 21.6739 30.6308 22.6869C30.6325 24.0194 30.6325 25.3519 30.6291 26.6844C30.6291 26.8245 30.668 26.8655 30.8066 26.8638C31.3815 26.8587 31.958 26.8638 32.5329 26.8689C32.6191 26.8689 32.7053 26.8775 32.7882 26.8946C33.0096 26.9424 33.0553 27.0466 32.9352 27.2431C32.8795 27.3336 32.8135 27.4207 32.7408 27.4959C31.6858 28.5671 30.6325 29.6382 29.5741 30.7076C29.2359 31.051 28.8876 31.3858 28.5427 31.7224C28.4869 31.7753 28.4277 31.8232 28.3652 31.8659C28.1149 32.0418 27.9121 32.047 27.6669 31.8676C27.5198 31.7617 27.3812 31.6404 27.2527 31.5105C25.9187 30.1661 24.5864 28.8182 23.2574 27.4669C23.1661 27.3746 23.0968 27.2567 23.0309 27.144C22.9632 27.0364 23.0123 26.951 23.1239 26.9219C23.2304 26.8929 23.342 26.8741 23.4502 26.8724C24.0335 26.8638 24.6134 26.8604 25.1933 26.8638C25.3269 26.8638 25.3742 26.8348 25.3726 26.6879C25.3658 25.9909 25.3692 25.2956 25.3692 24.6037Z",
    fill: "url(#paint_linear_3)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84",
    d: "M21.006 31L21.9927 31C22.1033 31 22.0722 31.0936 22.0722 31.1578C22.0739 31.8221 22.0722 32.4846 22.0739 33.1489C22.0739 33.2186 22.0739 33.292 22.0826 33.3617C22.1137 33.6205 22.3055 33.8242 22.5509 33.8554C22.6113 33.8645 22.6736 33.8645 22.7358 33.8645L33.2702 33.8645C33.3618 33.8645 33.4568 33.8627 33.545 33.8352C33.7903 33.7655 33.932 33.5416 33.9338 33.2333C33.9372 32.5598 33.9338 31.8845 33.9338 31.2092C33.9338 31 33.9338 31 34.136 31L35 31L35 33.2039C34.9983 34.2609 34.3088 34.9968 33.3151 34.9986C29.7743 35.0005 26.23 35.0005 22.6874 34.9986C21.6937 34.9986 21.0042 34.2628 21.0008 33.2058C20.999 32.5304 21.0008 31.857 21.0008 31.1817C21.006 31.1285 21.006 31.0734 21.006 31Z",
    fill: "url(#paint_linear_4)",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("line", {
    id: "\\u8DEF\\u5F84-13",
    x1: 18.7832031,
    x2: 24.7061424,
    y1: 15.3017578,
    y2: 15.3017578,
    stroke: "rgb(255,255,255)",
    strokeLinecap: "round",
    strokeWidth: 2
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadStep1);
export default __webpack_public_path__ + "static/media/download-step-1.9b032a4b2d7dbc0f77acb7b0262cf6d5.svg";
export { ForwardRef as ReactComponent };